import React, { Component } from 'react';
import PropTypes from 'prop-types';

import GlobalStyles from '../atoms/GlobalStyles';
import styled, { ThemeProvider } from 'styled-components';
import { theme } from '../../utils/styling';
import Header from '../molecules/Header';
import Navigation from '../molecules/Navigation';
import Image from '../atoms/Image';
import Colours from './Colours';

const Holder = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-flow: dense;
  @media( ${props => props.theme.breakpoints.md} ) {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    height: 100vh;
  }
`;

const HeaderHolder = styled.div`
  align-self: start;
  position: relative;
  padding: 2rem;
  display: ${props => props.exercise ? 'none' : 'block'};
  @media( ${props => props.theme.breakpoints.md} ) {
    display: block;
  }
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: ${props => props.theme.colours.greyFaint};
    z-index: -1;
    opacity: 0.6;
    filter: blur(5rem);
  }
`;

const ContentHolder = styled.div`
  padding: ${props => props.exercise ? '0' : '2rem'};
  @media( ${props => props.theme.breakpoints.md} ) {
    grid-row: span 2;
  }
`;

const NavHolder = styled.div`
  padding: 2rem;
  display: ${props => props.exercise ? 'none' : 'block'};
  @media( ${props => props.theme.breakpoints.md} ) {
    display: block;
    align-self: end;
  }
`;

const Main = styled.main`
  height: 100%;
`;

class Layout extends Component {

  render() {
    return (
      <ThemeProvider theme={theme}>
        <Colours theme={this.props.colourTheme}>
        <Holder>
          <Image
            imgName={this.props.bgImg}
            style={{
              zIndex: -1,
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
            }}/>
          <GlobalStyles/>
          <HeaderHolder exercise={this.props.exercise}>
            <Header
              mins={this.props.mins}
              pageTitle={this.props.pageTitle}/>
          </HeaderHolder>
          <ContentHolder exercise={this.props.exercise}>
            <Main>{this.props.children}</Main>
          </ContentHolder>
          {/*
          <NavHolder exercise={this.props.exercise}>
            <Navigation pageTitle={this.props.pageTitle}/>
          </NavHolder>
          */}
        </Holder>
        </Colours>
      </ThemeProvider>
    )
  }
}


Layout.propTypes = {
  pageTitle: PropTypes.string.isRequired,
  bgImg: PropTypes.string.isRequired,
  exercise: PropTypes.bool.isRequired,
  children: PropTypes.node,
  colourTheme: PropTypes.object,
  mins: PropTypes.number,
};

Layout.defaultProps = {
  exercise: false,
  bgImg: 'at-bits.png',
  mins: 10,
};

export default Layout;
